import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import i18n from "@/assets/lang/index";
import store from "@/store";
const t = i18n.global.t;

let routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    meta: {
      title: t("home.title"),
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
    meta: {
      title: t("login.title"),
    },
  },
  {
    path: "/wxLogin",
    name: "wxLogin",
    component: () => import("@/views/WxLoginView.vue"),
    meta: {
      title: t("login.title"),
    },
  },
  {
    path: "/reset",
    name: "reset",
    component: () => import("@/views/ResetView.vue"),
    meta: {
      title: t("reset.title"),
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/RegisterView.vue"),
    meta: {
      title: t("register.title"),
    },
  },
  {
    path: "/license",
    name: "license",
    component: () => import("@/views/LicenseView.vue"),
    meta: {
      title: t("license.title"),
    },
  },
];
const systemRoutes: Array<RouteRecordRaw> = [
  {
    path: "/user",
    name: "user:page",
    component: () => import("@/views/system/UserView.vue"),
    meta: {
      title: t("system.user.title"),
    },
  },
  {
    path: "/org",
    name: "org:page",
    component: () => import("@/views/system/OrgView.vue"),
    meta: {
      title: t("system.org.title"),
    },
  },
  {
    path: "/perm",
    name: "perm:page",
    component: () => import("@/views/system/PermView.vue"),
    meta: {
      title: t("system.perm.title"),
    },
  },
  {
    path: "/role",
    name: "role:page",
    component: () => import("@/views/system/RoleView.vue"),
    meta: {
      title: t("system.role.title"),
    },
  },
  {
    path: "/dict",
    name: "dict:page",
    component: () => import("@/views/system/DictView.vue"),
    meta: {
      title: t("system.dict.title"),
    },
  },
  {
    path: "/msg",
    name: "msg:page",
    component: () => import("@/views/system/MsgView.vue"),
    meta: {
      title: t("system.msg.title0"),
    },
  },
  {
    path: "/file",
    name: "file:page",
    component: () => import("@/views/system/FileView.vue"),
    meta: {
      title: t("system.file.title"),
    },
  },
  {
    path: "/config",
    name: "config:page",
    component: () => import("@/views/system/ConfigView.vue"),
    meta: {
      title: t("system.config.title"),
    },
  },
];

const rezRoutes: Array<RouteRecordRaw> = [
  {
    path: "/shop",
    name: "shop:page",
    component: () => import("@/views/rez/ShopView.vue"),
    meta: {
      title: t("rez.shop.title"),
    },
  },
  {
    path: "/rez",
    name: "rez:page",
    component: () => import("@/views/rez/RezView.vue"),
    meta: {
      title: t("rez.rez.title"),
    },
  },
  {
    path: "/reward",
    name: "reward:page",
    component: () => import("@/views/rez/RewardView.vue"),
    meta: {
      title: t("rez.reward.title"),
    },
  },
  {
    path: "/shop/:id/room",
    name: "room:page",
    component: () => import("@/views/rez/RoomView.vue"),
    meta: {
      title: t("rez.room.title"),
    },
  },
  {
    path: "/salaryArc",
    name: "salaryArc:page",
    component: () => import("@/views/rez/SalaryArcView.vue"),
    meta: {
      title: "薪资存档",
    },
  },
  {
    path: "/room/:id/device",
    name: "device:page",
    component: () => import("@/views/rez/DeviceView.vue"),
    meta: {
      title: t("rez.device.title"),
    },
  },
  {
    path: "/member",
    name: "member:page",
    component: () => import("@/views/rez/MemberView.vue"),
    meta: {
      title: t("rez.member.title"),
    },
  },
  {
    path: "/rechargeCard",
    name: "rechargeCard:page",
    component: () => import("@/views/rez/RechargeCardView.vue"),
    meta: {
      title: t("rez.rechargeCard.title"),
    },
  },
  {
    path: "/employee",
    name: "employee:page",
    component: () => import("@/views/rez/EmployeeView.vue"),
    meta: {
      title: "员工管理",
    },
  },
  {
    path: "/dashboard",
    name: "rez:dashboard",
    // component: () => import("@/views/rez/DashboardView.vue"),
    component: () => {
      const projectType = store.getters.projectType;
      // const project = store.state.project;
      if (projectType === "mate") {
        return import("@/views/rez/MateDashboardView.vue");
      } else {
        return import("@/views/rez/DashboardView.vue");
      }
    },
    meta: {
      title: t("rez.dashboard.title"),
    },
  },
  {
    path: "/salary/dashboard",
    name: "salary:dashboard",
    // component: () => import("@/views/rez/DashboardView.vue"),
    component: () => {
      return import("@/views/salary/DashboardView.vue");
    },
    meta: {
      title: t("rez.dashboard.title"),
    },
  },
];

const mRezRoutes: Array<RouteRecordRaw> = [
  {
    path: "/m",
    name: "m:home",
    component: () => import("@/views/m/HomeView.vue"),
    meta: {
      title: t("home.title"),
    },
  },
  {
    path: "/m/rez",
    name: "m:rez:page",
    component: () => import("@/views/m/rez/RezView.vue"),
    meta: {
      title: t("rez.rez.title"),
    },
  },
  {
    path: "/m/room",
    name: "m:room:page",
    component: () => import("@/views/m/rez/RoomView.vue"),
    meta: {
      title: t("rez.room.title"),
    },
  },
  {
    path: "/m/dashboard",
    name: "m:rez:dashboard",
    // component: () => import("@/views/rez/DashboardView.vue"),
    component: () => {
      const projectType = store.getters.projectType;
      // const project = store.state.project;
      if (projectType === "mate") {
        return import("@/views/rez/MateDashboardView.vue");
      } else {
        return import("@/views/m/rez/DashboardView.vue");
      }
    },
    meta: {
      title: t("rez.dashboard.title"),
    },
  },
];

const catRoutes: Array<RouteRecordRaw> = [
  {
    path: "/category",
    name: "category:page",
    component: () => import("@/views/cat/CategoryView.vue"),
    meta: {
      title: "商品类别",
    },
  },
  {
    path: "/product",
    name: "product:page",
    component: () => import("@/views/cat/ProductView.vue"),
    meta: {
      title: "商品管理",
    },
  },
  {
    path: "/productSet",
    name: "productSet:page",
    component: () => import("@/views/cat/ProductSetView.vue"),
    meta: {
      title: "商品组合",
    },
  },
  {
    path: "/productSetPhone",
    name: "productSetPhone:page",
    component: () => import("@/views/cat/ProductSetPhoneView.vue"),
    meta: {
      title: "手机号兑换商品组合",
    },
  },
];

const ponitRoutes: Array<RouteRecordRaw> = [
  {
    path: "/coupon",
    name: "coupon:page",
    component: () => import("@/views/point/CouponView.vue"),
    meta: {
      title: "优惠券管理",
    },
  },
  {
    path: "/couponCode",
    name: "couponCode:page",
    component: () => import("@/views/point/CouponCodeView.vue"),
    meta: {
      title: "优惠券口令",
    },
  },
  {
    path: "/userCoupon",
    name: "userCoupon:page",
    component: () => import("@/views/point/UserCouponView.vue"),
    meta: {
      title: "用户优惠券管理",
    },
  },
  {
    path: "/pointRecord",
    name: "pointRecord:page",
    component: () => import("@/views/point/PointRecordView.vue"),
    meta: {
      title: "积分流水",
    },
  },
];

const gachaRoutes: Array<RouteRecordRaw> = [
  {
    path: "/gachaPool",
    name: "gachaPool:page",
    component: () => import("@/views/gacha/GachaPoolView.vue"),
    meta: {
      title: "奖池管理",
    },
  },
  {
    path: "/gachaPrize",
    name: "gachaPrize:page",
    component: () => import("@/views/gacha/GachaPrizeView.vue"),
    meta: {
      title: "奖品管理",
    },
  },
  {
    path: "/gachaPoolPrize",
    name: "gachaPoolPrize:page",
    component: () => import("@/views/gacha/GachaPoolPrizeView.vue"),
    meta: {
      title: "奖池奖品配置",
    },
  },
  {
    path: "/gachaPlay",
    name: "gacha:play",
    component: () => import("@/views/gacha/GachaPlayView.vue"),
    meta: {
      title: "抽奖",
    },
  },
  {
    path: "/gachaDraw",
    name: "gachaDraw:page",
    component: () => import("@/views/gacha/GachaDrawView.vue"),
    meta: {
      title: "抽奖记录",
    },
  },
  {
    path: "/gachaUserPrize",
    name: "gachaUserPrize:page",
    component: () => import("@/views/gacha/GachaUserPrizeView.vue"),
    meta: {
      title: "奖品记录",
    },
  },
];

const tempRoutes: Array<RouteRecordRaw> = [
  {
    path: "/temp",
    name: "temp:page",
    component: () => import("@/views/temp/TempView.vue"),
    meta: {
      title: t("temp"),
    },
  },
];
routes = routes.concat(
  systemRoutes,
  rezRoutes,
  mRezRoutes,
  catRoutes,
  ponitRoutes,
  gachaRoutes,
  tempRoutes
);
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  // history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title}`;
  }
  next();
});
export default router;
